// src/lib/utils/notify.js  (or .ts if your build supports it)
import { supabase } from "../supabaseClient";

export async function notifyUser({
  userId,
  title,
  body,
  type = "generic", // <-- matches your column name
  link = null, // optional: route or URL to the report
  email = null, // optional: store reporter email if you like
}) {
  const { data, error } = await supabase
    .from("notifications")
    .insert({
      user_id: userId,
      title,
      body,
      type, // <-- use 'type'
      link, // optional
      email, // optional
      is_read: false,
    })
    .select()
    .single();

  if (error) throw error;
  return data;
}
